/** 
 Copyright Highway9 Networks Inc. 
 */ 
import { RequestOptions } from "../types/requestOptions";
import { authenticationService } from "./authentication-service";

// Convert Blob to base64 string
function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      resolve(result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function getImageSrc(id: string) {
  const requestOptions: RequestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: "Bearer " + authenticationService.currentUserValue?.token,
    },
    cache: "force-cache",
  };

  try {
    // request URL
    const reqUrl = `/api/v1/orch/image-files/${id}`;
    // get the image
    const blob = await (await fetch(reqUrl, requestOptions)).blob();
    // create a url for the image
    const url = URL.createObjectURL(blob);
    return url;
  } catch (error) {
    console.log(error, id);
    throw error;
  }
}

export async function getImageSrcBase64(id: string) {
  const requestOptions: RequestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json", 
      accept: "application/json",
      Authorization: "Bearer " + authenticationService.currentUserValue?.token,
    },
    cache: "force-cache",
  };  

  try {
    // request URL
    const reqUrl = `/api/v1/orch/image-files/${id}`;
    // get the image
    const blob = await (await fetch(reqUrl, requestOptions)).blob();
    // convert the blob to base64
    const base64 = await blobToBase64(blob);
    return base64;
  } catch (error) {
    console.log(error, id);
    throw error;
  }
}

